<script>
export default {
  props: ['slotFunction', 'slotData'],
  render: function (/*createElement*/) {
    return this.slotFunction(this.slotData)
  }
}
</script>
